import step1 from '~shared-assets/images/calculator-step1-norlys.svg';
import step2 from '~shared-assets/images/calculator-step2.svg';
import step3 from '~shared-assets/images/calculator-step3.svg';

import { NorlysFont } from '~src/branding';
import { ButtonNorlys } from '~src/components/Button';
import { Heading, Text } from '~src/components/Typography';

import { StepImage } from './images';
import { StepContainer, StepIcon } from './style';

type WelcomeInformationProps = { onProceed?: () => void };

export const WelcomeInformationNorlys = ({ onProceed }: WelcomeInformationProps) => (
  <div style={{ display: 'flex', flexFlow: 'row wrap', margin: 0 }}>
    <Text style={{ ...NorlysFont.style('default', 16) }}>
      Du er nu i gang med første skridt på vejen mod at få energioptimeret din bolig. Det er en længere rejse, men her
      har vi fremhævet de 3 første skridt du kan tage, for at komme i gang med at finde den bedst mulige løsning til din
      bolig.
    </Text>

    <div style={{ display: 'flex' }}>
      <StepContainer>
        <span />
        <StepImage src={step1} />

        <span />
        <StepImage src={step2} />

        <span />
        <StepImage src={step3} />

        <StepIcon norlys primary>
          1
        </StepIcon>
        <Heading style={{ alignSelf: 'center', ...NorlysFont.style('heading', 22) }}>
          Udfyld energiberegneren på bare 5 min
        </Heading>

        <StepIcon norlys>2</StepIcon>
        <Heading style={{ alignSelf: 'center', ...NorlysFont.style('heading', 22) }}>
          Modtag et uforpligtende tilbud efter 10 min
        </Heading>

        <StepIcon norlys>3</StepIcon>
        <Heading style={{ alignSelf: 'center', ...NorlysFont.style('heading', 22) }}>
          Vores rådgiver kontakter dig
        </Heading>

        <span />
        <Text style={{ ...NorlysFont.style('default', 16) }}>
          Brug 5 minutter på at udfylde vores energiberegner og se præcist hvor mange penge du kan spare med et
          energirigtigt hjem.
        </Text>

        <span />
        <Text style={{ ...NorlysFont.style('default', 16) }}>
          Når du har færdiggjort energiberegningen, modtager du et uforpligtende tilbud med alle detaljer om din
          løsning.
        </Text>

        <span />
        <Text style={{ ...NorlysFont.style('default', 16) }}>
          Book et gratis uforpligtende møde med en af vores kompetente energirådgivere, der kan guide dig videre i
          processen.
        </Text>
      </StepContainer>
    </div>

    <ButtonNorlys style={{ margin: '16px auto 0 auto' }} onClick={() => onProceed?.()}>
      Kom i gang
    </ButtonNorlys>
  </div>
);
